module.exports = {
  header: {
    logo: require('./widgets/widget_logo'),
  },
  login: {
    login_banner: require('./widgets/widget_login_banner'),
  },
  home: {
    home_banner: require('./widgets/widget_home_banner'),
  },
  user: {
    privacy_policy: require('./widgets/widget_privacy_policy'),
    consent_text: require('./widgets/widget_consent_text'),
    message_permission: require('./widgets/widget_message_permission'),
    user_agreement: require('./widgets/widget_user_agreement'),
  },
  basket: {
    basket_messages: require('./widgets/widget_basket_messages'),
  }
};



// WEBPACK FOOTER //
// ./src/plugins/tfs/platformConfigs/widgets.js